import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'events',
    component: () => import('@/pages/EventsPage.vue'),
    meta: { title: 'Events' }
  },
  {
    path: '/details/:id',
    name: 'event-detail',
    component: () => import('@/pages/EventDetailPage.vue'),
    meta: { title: 'Event Detail' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/NotFoundPage.vue'),
    meta: { title: '404 - Not Found' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Update page title on navigation
router.beforeEach((to, _from, next) => {
  const siteName = import.meta.env.VITE_SITE_NAME || 'Event Site'
  document.title = to.meta.title ? `${to.meta.title} - ${siteName}` : siteName
  next()
})

export default router